<template>
  <div class="add-contact-category">
    <el-form label-width="80px" :model="formData">
      <el-form-item label="排序">
        <el-input-number v-model="formData.sort_order" :min="0" :max="999" />
      </el-form-item>
      <el-form-item v-for="item in formData.languageList" :key="item.code" :label="item.name">
        <el-input v-model="item.value" :placeholder="'请输入' + item.name + '分类名称'" />
      </el-form-item>
    </el-form>
    <div class="form-actions">
      <el-button @click="$emit('cancel')">取消</el-button>
      <el-button type="primary" @click="handleSubmit">保存</el-button>
    </div>
  </div>
</template>

<script>
import { getLanguage } from "@/api/public"
import { addContactCategory, updateContactCategory } from "@/api/website"

export default {
  name: 'AddContactCategory',
  props: {
    editItem: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      formData: {
        sort_order: 0,
        languageList: []
      },
      languageList: []
    }
  },
  watch: {
    editItem: {
      handler(val) {
        if (val) {
          this.formData.sort_order = val.sort_order || 0
          this.languageList.forEach(lang => {
            var t = val.translations ? val.translations[lang.code] : null
            var item = this.formData.languageList.find(function(i) { return i.code === lang.code })
            if (item) {
              item.value = t ? t.name : ''
            }
          })
        } else {
          this.resetForm()
        }
      },
      immediate: true,
      deep: true
    }
  },
  mounted() {
    this.getLanguageList()
  },
  methods: {
    resetForm() {
      this.formData.sort_order = 0
      this.formData.languageList = []
      this.languageList.forEach(function(item) {
        this.formData.languageList.push({
          code: item.code,
          name: item.name,
          value: ''
        })
      }.bind(this))
    },
    async getLanguageList() {
      var res = await getLanguage()
      if (res.code === 200) {
        this.languageList = res.data || []
        this.formData.languageList = []
        res.data.forEach(function(item) {
          this.formData.languageList.push({
            code: item.code,
            name: item.name,
            value: ''
          })
        }.bind(this))
      }
    },
    handleSubmit() {
      var categories = {}
      this.formData.languageList.forEach(function(item) {
        categories[item.code] = item.value
      })
      var data = {
        sort_order: this.formData.sort_order,
        categories: categories
      }
      data = JSON.stringify(data)

      if (this.editItem) {
        updateContactCategory(this.editItem.id, JSON.parse(data)).then(function(res) {
          if (res.code === 200) {
            this.$emit('save', true)
          }
        }.bind(this))
      } else {
        addContactCategory(data).then(function(res) {
          if (res.code === 200) {
            this.$emit('save', true)
          }
        }.bind(this))
      }
    }
  }
}
</script>

<style scoped lang="scss">
.add-contact-category {
  box-sizing: border-box;
  padding: 0 20px;
}

.form-actions {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  margin-top: 30px;
  padding-top: 20px;
  border-top: 1px solid #f0f2f5;
}

@media (max-width: 768px) {
  .add-contact-category {
    padding: 10px 0;
  }
  .form-actions {
    flex-direction: column;
  }
  .form-actions .el-button {
    width: 100%;
  }
}
</style>
